/**
 * Start Group Section Component
 *
 * Component shown when user is not part of any organization yet.
 */

import { Business, Email } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
} from '@mui/material';

export function StartGroupSection() {
  return (
    <Card sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <CardContent sx={{ textAlign: 'center', py: 4 }}>
        <Business sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          Welcome to Organization Management
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          You&apos;re not currently part of any organization. To get started with team collaboration,
          you&apos;ll need to be invited by an organization administrator.
        </Typography>
        <Box sx={{ mt: 4 }}>
          <Button
            variant="outlined"
            size="large"
            startIcon={<Email />}
            onClick={() => window.location.href = 'mailto:support@smartscribe.health'}
          >
            Contact Support
          </Button>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          If you believe you should have access to an organization, please contact your administrator
          or reach out to our support team.
        </Typography>
      </CardContent>
    </Card>
  );
}